import { useGetFaultsQuery } from '@/store/api/diagnosticApi';
import { useParams } from 'react-router-dom';
import { useAppFilters } from '@/hooks';
import { ASSETS_TYPE, ASSETS_PREVIEW, ASSET_STUDIO } from '@/types/shared/navigation-tabs.enums';

type MappedAssetsType = ASSETS_TYPE.FIXED | ASSETS_TYPE.MOBILE;

const assetTypeMap: Record<MappedAssetsType, string> = {
  [ASSETS_TYPE.FIXED]: 'fa',
  [ASSETS_TYPE.MOBILE]: 'mf',
};

export function useFetchFaults() {
  const { siteId } = useParams();
  const { assetsType: assetsCategory, selectedAsset, selectedComponent } = useAppFilters();
  const assetsType = assetTypeMap[assetsCategory as MappedAssetsType];

  const shouldSkip = !siteId || !assetsCategory;

  const { data: faultsRaw, isLoading, isFetching, error } = useGetFaultsQuery(
    {
      site_id: siteId!,
      assets_type: assetsType,
      ...(selectedAsset && selectedAsset !== ASSETS_PREVIEW.ALL_ASSETS && { asset_id: selectedAsset }),
      ...(selectedComponent && selectedComponent !== ASSET_STUDIO.ALL_COMPONENTS && { component_id: selectedComponent }),
    },
    {
      skip: shouldSkip,
    }
  );

  return { faultsRaw, isLoading: isLoading || shouldSkip, isFetching, error };
}
